export default [
    {
        path: '/identity-verification',
        component: () => import('@/pages/identity-verification/IdentityVerification.vue'),
        children: [
            {
                name: 'identity-verification-attempt',
                path: '',
                component: () => import('@/components/identity-verification/IdentityVerificationAttempt.vue'),
                meta: {
                    title: 'Verify Identitiy',
                },
            },
        ],
    },
];
